// // CreateCambioServicePage.tsx

import { SaveCambioService } from "../../components";
// import { PermissionsEnum } from "@/auth/interfaces";

export default function CreateCambioServicePage() {
  

  
  return (
    <SaveCambioService
      titulo="Crear Control de cambios"
    />
  )
}
